/**
 * EDELHOLZ Contact Form → Close CRM Hook
 * Intercepts Shopify contact form submissions and creates Close leads + Slack notifications
 */
(function() {
  // Only run on pages with a contact form
  var forms = document.querySelectorAll('form[action="/contact#contact_form"], form[action="/contact"]');
  if (!forms.length) return;

  forms.forEach(function(form) {
    form.addEventListener('submit', function() {
      // Extract form data
      var formData = new FormData(form);
      var name = '';
      var email = '';
      var phone = '';
      var body = '';

      // Shopify contact forms use contact[email], contact[body] etc.
      formData.forEach(function(value, key) {
        if (key === 'contact[email]' || key === 'email') email = value;
        if (key === 'contact[name]' || key === 'name') name = value;
        if (key === 'contact[phone]' || key === 'phone') phone = value;
        if (key === 'contact[body]' || key === 'body' || key === 'contact[note]') body = value;
        // Prestige uses block-based fields — check for common patterns
        if (key.includes('Name') || key.includes('name')) { if (!name && value) name = value; }
        if (key.includes('Email') || key.includes('email') || key.includes('E-Mail')) { if (!email && value) email = value; }
        if (key.includes('Phone') || key.includes('phone') || key.includes('Telefon')) { if (!phone && value) phone = value; }
        if (key.includes('body') || key.includes('Nachricht') || key.includes('message')) { if (!body && value) body = value; }
      });

      if (!email) return; // No email = nothing to do

      // Send to VPS → Close CRM lead
      try {
        fetch('https://dashboard.edelholz-manufaktur.de/api/beratung', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: name || 'Kontaktformular',
            email: email,
            phone: phone || '',
            type: 'Kontaktformular',
            products: '',
            message: body || '',
            calendly: false,
            configCode: ''
          })
        });
      } catch(e) {}

      // Slack notification
      try {
        var slackLines = [
          ':envelope: *Neue Kontaktanfrage* (Kontaktseite)',
          '',
          '*Name:* ' + (name || '-'),
          '*E-Mail:* ' + email
        ];
        if (phone) slackLines.push('*Telefon:* ' + phone);
        if (body) slackLines.push('*Nachricht:* ' + body.substring(0, 500));

        fetch('https://hooks.slack.com/services/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', {
          method: 'POST',
          body: JSON.stringify({ text: slackLines.join('\n') }),
          mode: 'no-cors'
        });
      } catch(e) {}
    });
  });
})();
